import { render } from "./CartItem.vue?vue&type=template&id=49093ee6&scoped=true"
import script from "./CartItem.vue?vue&type=script&lang=js"
export * from "./CartItem.vue?vue&type=script&lang=js"

import "./CartItem.vue?vue&type=style&index=0&id=49093ee6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-49093ee6"

export default script